import React from 'react';
import './LoadingScreen.css';
import logo from '../logo.PNG';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <img src={logo} alt="Falcons Logo" className="loading-logo" />
      <div className="spinner"></div>
      <h2>Loading...</h2>
    </div>
  );
};

export default LoadingScreen;
